import { render, staticRenderFns } from "./BCCView.vue?vue&type=template&id=1e5df982&scoped=true"
import script from "./BCCView.vue?vue&type=script&lang=ts"
export * from "./BCCView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5df982",
  null
  
)

export default component.exports